export default {
    '10': '待审批',
    '20': '审批通过',
    '30': '审批未通过',
    '40': '单位退出',
    '50': '项目退出',
}